import classNames from 'classnames';
import { useContext } from 'react';

import TableContext from '../table/table-context';

export interface TableIconCellProps {
  className?: string;
  iconWrapperClassName?: string;
  size?: 'small' | 'medium' | 'xs'; // will also be passed from `Table` component via `TableContext`
  align?: 'inherit' | 'left' | 'right' | 'center' | 'justify';
}

export function TableIconCell({
  className,
  children,
  iconWrapperClassName,
  size: sizeProp,
  align = 'inherit',
}: React.PropsWithChildren<TableIconCellProps>) {
  const table = useContext(TableContext);
  const { size }: TableIconCellProps = {
    size: sizeProp || table?.size || 'medium',
  };

  return (
    <td
      className={classNames(
        size === 'medium' && ['first:pl-2 first:pr-0', 'last:pl-0 last:pr-2', 'py-3', 'text-base'],
        size === 'small' && ['first:pl-1 first:pr-2', 'last:pl-2 last:pr-1', 'py-1', 'text-sm'],
        size === 'xs' && ['first:pl-1 first:pr-2', 'last:pl-2 last:pr-1', 'py-2', 'text-xs'],
        align === 'inherit' && '[text-align:inherit]',
        align === 'left' && 'text-left',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        align === 'justify' && 'text-justify',
        'w-0',
        'text-gray-900 dark:text-gray-100',
        'whitespace-nowrap text-center [vertical-align:inherit]',
        className
      )}
    >
      <div className={classNames('flex items-start justify-center', iconWrapperClassName)}>{children}</div>
    </td>
  );
}

export default TableIconCell;
